<!--<div class="login-h3" style=" background:none; color:#333;">
  <span style=" background:none; color:#333; cursor: pointer;" (click)="userType = 1">个人用户</span>
  <span style=" background:none; color:#333;cursor: pointer;" (click)="userType = 2">企业用户</span>
</div>-->
<nz-tabset [nzSelectedIndex]="0">
  <nz-tab nzSelect><ng-template #nzTabHeading>请输入验证码</ng-template></nz-tab>
</nz-tabset>
<form nz-form [formGroup]="formModel" class="login-form" (ngSubmit)="validate()">
  <div nz-form-item>
    <div nz-form-control>
      <div nz-row [nzGutter]="8">
        <div nz-col [nzSpan]="16">
          <nz-input formControlName="captcha" [nzPlaceHolder]="'请输入验证码'" [nzSize]="'large'"></nz-input>
        </div>
        <div nz-col [nzSpan]="8">
          <img [src]="captcha" (click)="changeCap()" class="codeBeforeClass captcha"
               alt="验证码" title="点击更换验证码"/>
        </div>
      </div>
      <div nz-form-explain [hidden]="formModel.get('captcha').valid || formModel.get('captcha').pristine">
        <span *ngIf="formModel.hasError('required',['captcha'])">*请输入验证码</span>
      </div>
    </div>
  </div>

  <div nz-form-item>
    <div nz-form-control>
      <button nz-button id="login-submit" class="login-form-button marB5" [nzType]="'primary'" [nzSize]="'large'">确定</button>
    </div>
  </div>
</form>



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/captcha/captcha.component.html